<template>
  <div class="upload" @mouseenter="enter" @mouseleave="leave">
    <el-button class="upload-btn" :class="!btn?'bg':''" type="file" ref="file">
      <i v-show="!src" class="el-icon-plus" />
      <span v-show="btn">更换二维码</span>
    </el-button>
    <img :src="src" v-if="src" alt />
  </div>
</template>

<script>
import { getToken } from '@/utils/auth'; // getToken from cookie
import plupload from 'plupload';
import { API_URL } from '@/utils/request';

export default {
  props: {
    src: String,
  },

  data: () => ({
    btn: false,
  }),

  computed: {},

  watch: {},

  mounted() {
    console.log(this.src);
    this.initUploader();
  },

  methods: {
    enter() {
      if (this.src) {
        this.btn = true;
      }
    },
    leave() {
      if (this.src) {
        this.btn = false;
      }
    },

    // 上传图片
    initUploader() {
      var uploader = new plupload.Uploader({
        browse_button: this.$refs.file.$el, //触发文件选择对话框的按钮，为那个元素id
        url: `${API_URL}?do=picture_add`, //服务器端的上传页面地址
        file_data_name: 'picture',
        multipart_params: {
          sid: getToken(),
          type: 'taobaoke',
        },
        filters: {
          max_file_size: '10240kb',
        },
        resize: {
          quality: 60,
          preserve_headers: false,
        },
        max_retries: 2,
      });
      uploader.init();

      uploader.bind('FilesAdded', (uploader) => {
        uploader.start();
      });
      uploader.bind('FileUploaded', (uploader, file, responseObject) => {
        let data = JSON.parse(responseObject.response);
        if (data.error_code == 0) {
          this.uploader(data.file);
        } else {
          this.$message.error(data.error_message);
        }
      });
      uploader.bind('Error', (uploader, errObject) => {
        this.$message.error(errObject.message);
      });
    },

    // 上传图片
    uploader(filePath) {
      this.$emit('changeFace', filePath);
    },
  },
};
</script>

<style lang="scss" scoped>
i {
  font-size: 28px;
  color: $theme-textplaceholder;
  position: relative;
  z-index: 0;
  opacity: 1;
  transition: all 0.3s ease;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.upload {
  width: 148px;
  height: 148px;
  border-style: solid;
  border-width: 1px;
  border-radius: 2px;
  cursor: pointer;
  border-color: $theme-border3;
  .upload-btn {
  cursor: pointer;
    position: absolute;
    width: 148px;
    height: 148px;
    background: rgba(0, 0, 0, 0.4);
    border: none;
    outline: none;
    color: #fff;
    font-size: 14px;
  }
  .bg{
    background: transparent;
  }
  img {
    width: 148px;
    height: 148px;
  }
}
</style>